import LabServiceCollection from "@/collections/LabServiceCollection";
import InstrumentTestModel from "@/models/lab/InstrumentTestModel";

export default class InstrumentTestCollection extends LabServiceCollection {

  model() {
    return InstrumentTestModel;
  }

}
